import { toast } from 'react-toastify';
import { browserHistory } from 'react-router';

import RegisterApi from '../../../../api/register-api';
import SharedApi from '../../../../api/shared-api';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import { login } from '../../login/actions/login-actions';
import registerActionTypes from '../constants/action-types';
import constants from '../../../../common/constants';
import registerConstants from '../constants/register-constants';
import CookiesWrapper from '../../../../common/cookies-wrapper';

export const register = data => {
  return async dispatch => {
    try {
      dispatch(handleHttpInProgress(true));

      await RegisterApi.register(data);

      dispatch(handleHttpInProgress(false));
      localStorage.removeItem(constants.user_register_key_word);
      CookiesWrapper.removeCookie(registerConstants.utm_params_cookie);
      dispatch(login(data.username, data.password));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
      toast.error('Something went wrong please contact our support.');
    }
  };
};

export const getCountries = () => {
  return async dispatch => {
    dispatch(handleHttpInProgress(true));
    try {
      const response = await SharedApi.getCountries();
      const countries = response && response.data;
      countries.forEach(country => {
        country.icon = `${constants.flags_base_url}${country.code.toLowerCase()}.png`;
      });
      dispatch(handleGetCountries(countries));
      dispatch(handleHttpInProgress(false));
    } catch (error) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const checkUserExist = (username, email, path, registerData, registerCallback) => {
  return async dispatch => {
    try {
      dispatch(handleHttpInProgress(true));
      const response = await RegisterApi.checkUserExist(username, email);
      const userExist = response && response.data && response.data.user_exists;

      dispatch(
        handleCheckUserExist({
          username: response.data.user_name ? 'REGISTER.USERNAME_EXIST' : null,
          email: response.data.email ? 'REGISTER.EMAIL_EXIST' : null,
        })
      );

      dispatch(handleHttpInProgress(false));

      if (!userExist && registerData && registerCallback && (registerData.user_type === registerConstants.user_types.ifs_type || registerData.user_type === registerConstants.user_types.b2b)) {
        registerCallback(registerData);
        return;
      }

      if (response.data && !response.data.user_name && !response.data.email) {
        browserHistory.push(path);
      }
    } catch (errror) {
      dispatch(handleHttpInProgress(false));
    }
  };
};

export const handleRegisterError = error => {
  return {
    type: registerActionTypes.HANDLE_REGISTER_ERROR,
    data: error,
  };
};

export const handleGetCountries = countries => {
  return {
    type: registerActionTypes.HANDLE_GET_COUNTRIES,
    data: countries,
  };
};

export const handleCheckUserExist = data => {
  return {
    type: registerActionTypes.HANDLE_CHECK_USER_EXIST,
    data,
  };
};

export const toggleRegisterTypeModal = show => {
  return {
    type: registerActionTypes.TOGGLE_REGISTER_TYPE_MODAL,
    data: show,
  };
};



// WEBPACK FOOTER //
// ./src/app/main/register/actions/register-actions.js